import { z } from 'zod'
import { zId, zIsoDate } from '../common'

// GET /admin/site_audit?tenantId=… — site health report + optional live On-Page
// snapshot (DataForSEO). Outer keys are camelCase; nested page fields stay
// loose so a new check shape never rejects the parse.

export const zSiteAuditLivePage = z
  .object({
    url: z.string(),
    statusCode: z.number().nullable().optional(),
    checks: z.unknown().optional(),
    onpageScore: z.number().nullable().optional(),
    isEstimated: z.boolean().optional(),
  })
  .passthrough()
export type SiteAuditLivePage = z.infer<typeof zSiteAuditLivePage>

export const zSiteAuditLive = z
  .object({
    available: z.boolean(),
    capturedOn: z.string().nullable().optional(),
    pages: z.array(zSiteAuditLivePage).optional().default([]),
  })
  .passthrough()
export type SiteAuditLive = z.infer<typeof zSiteAuditLive>

// Full audit is mostly opaque for now — the front MVP only renders the live
// strip. Keep the rest as optional unknowns so future panels can type tighter
// without a migration.
export const zSiteAudit = z
  .object({
    tenantId: zId,
    generatedAt: zIsoDate.optional(),
    publishedCount: z.number().optional(),
    live: zSiteAuditLive,
  })
  .passthrough()
export type SiteAudit = z.infer<typeof zSiteAudit>
